import { BudgetMissionInput } from '../../lib/types/models/mission/mission-input'
import { MissionToExternalStaffParams } from '../../lib/types/models/mission-to-external-staff/mission-to-external-staff-params'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function includeBudgetToExternalStaff(input: MissionToExternalStaffParams) {
  const { id, externalStaffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.includeBudgetToExternalStaff.url, { id, externalStaffId }))
    .patch()
}

export function excludeBudgetToExternalStaff(input: MissionToExternalStaffParams) {
  const { id, externalStaffId } = input
  return restApiClient
    .url(constructApiUrl(API.missions.excludeBudgetToExternalStaff.url, { id, externalStaffId }))
    .patch()
}

export function updateBudgetToExternalStaff(
  input: BudgetMissionInput & MissionToExternalStaffParams
) {
  const { id, externalStaffId, ...rest } = input
  return restApiClient
    .url(constructApiUrl(API.missions.updateBudgetToExternalStaff.url, { id, externalStaffId }))
    .patch<never, BudgetMissionInput>(rest)
}
